module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/399.de9c541f.png";